import React, { useContext, useEffect, useState } from "react";
import axiosInstance from "../../../axiosInstance";
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";
import { getTheme } from "../../../styles/theme";
import { useSelector } from "react-redux";
import DateRangeContext from "../../../contexts/Dashboard/DateRange";
import axios from "axios";

export default function PerformanceCards({
  cards,
  setCards,
  loadingProfile,
  setLoadingProfile,
}) {
  const selectedBranchesString = useSelector(
    (state) => state?.branches?.branchesString
  );

  const theme = useTheme();

  const profile = useSelector((state) => state?.profile?.profile);
  const lightMode = useSelector((state) => state.mode.lightMode); // Redux state'inden lightMode değerini çekin
  const [loading, setLoading] = useState(true);
  const { startDate, setStartDate, endDate, setEndDate } =
    useContext(DateRangeContext);

  const paraFormat = (number) => {
    const formatter = new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
    });
    return formatter.format(number);
  };

  const getPerformances = async () => {
    const formattedStartDate = startDate.format("YYYY-MM-DD");
    const formattedEndDate = endDate.format("YYYY-MM-DD");

    if (window.cancelRequest) {
      window.cancelRequest.cancel(
        "New request made, cancelling previous request."
      );
    }
    window.cancelRequest = axios.CancelToken.source(); // Yeni bir Cancel Token oluştur

    try {
      setLoading(true);
      let accessToken = localStorage.getItem("accessToken");
      let token = localStorage.getItem("loginUser");
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}dashboard/performance?start_date=${formattedStartDate}&end_date=${formattedEndDate}`,
        {
          cancelToken: window.cancelRequest.token, // İptal tokenini istek ile gönder
          headers: {
            Authorization: `Bearer ${accessToken}`,
            XRefreshToken: `${token}`,
            Accounts: selectedBranchesString,
            "Content-Type": "application/json",
          },
        }
      );
      // API'den gelen veriyi işleme ve mevcut kartlara atama
      const updatedCards = cards.map((card) => {
        // Kartın id'sine göre API'den gelen veriyi al
        const apiValue = response.data[card.id];

        // total_commissions ve total_sales değerlerini paraFormat fonksiyonu ile formatlama
        if (card.id === "total_commissions" || card.id === "total_sales") {
          const formattedValue = paraFormat(apiValue);
          return { ...card, value: formattedValue };
        }

        if (apiValue !== undefined) {
          return { ...card, value: apiValue };
        }
        return card;
      });

      if (
        profile?.account_type !== "main_branch" ||
        profile?.agency_type === "Institution"
      ) {
        let newCards = updatedCards.filter((item) => {
          return item.id !== "total_commissions";
        });
        setCards(newCards);
        setLoadingProfile(false);
      } else {
        setCards(updatedCards);
        setLoadingProfile(false);
      }

      // setCards(updatedCards); // Güncellenmiş kartları set et
      setLoading(false);
    } catch (error) {
      if (axios.isCancel(error)) {
        // console.log("Request cancelled:", error.message);
      } else {
        setLoading(false);
        console.error("API isteği sırasında hata oluştu:", error);
      }
    }
  };
  useEffect(() => {
    // if (selectedBranchesString?.length) {
    //   getPerformances();
    // }
    getPerformances();
  }, [startDate, endDate, selectedBranchesString, profile]);

  return cards?.map((card, idx) => (
    <Grid
      key={idx}
      item
      xs={12}
      sm={6}
      // lg={profile?.account_type === "main_branch" ? 3 : 4}
      // xl={profile?.account_type === "main_branch" ? 3 : 4}
      lg={profile?.account_type === "main_branch" ? 3 : 3}
      xl={profile?.account_type === "main_branch" ? 3 : 3}
    >
      <Card
        sx={{
          height: "100%",
          background: lightMode ? "#ffffff" : "#292929",
          // borderImage: `linear-gradient(to bottom,  ${theme.palette.customRed.orange},  rgba(0, 0, 0, 0)) 1 100%`,
          padding: "1px",
          borderRadius: "1rem",
          color: "white",
     
          
          // "&:before": {
          //   content: "''",
          //   position: "absolute",
          //   left: "0",
          //   top: "0",
          //   width: "4px",
          //   height: "100%",
          //   backgroundColor: getTheme().palette.customRed.dark,
          // },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            padding: "1rem 1rem 1rem 1rem",
            position: "relative",
            width: "100%",
            height: "100%",
            background: lightMode ? "#ffffff" : "#292929",
          }}
        >
          {loading ? (
            <CircularProgress sx={{ margin: "auto" }} />
          ) : !loadingProfile ? (
            <>
              <Box
                sx={{
                  background: "#f9ece2",
                  minWidth: "90px",
                  display: "flex",
                  height: "90px",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "1rem",

                  // filter: `drop-shadow(2px 2px 1px ${
                  //   getTheme().palette.customRed.dark
                  // })`,
                  padding: ".5rem",
                }}
              >
                <img
                  style={{
                    fontSize: "48px",
                    color: theme.palette.primary.light,
                    filter: "drop-shadow(2px 2px 2px #aeaeae)",
                  }}
                  src={card.icon}
                  alt=""
                />
                {/* {React.createElement(card.icon, {
                  sx: {
                    fontSize: "48px",
                    color: theme.palette.primary.light,
                    filter: "drop-shadow(2px 2px 2px #aeaeae)",
                  },
                })} */}
              </Box>

              <CardContent
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  width: "100%",
                  height: "100%",
                  padding: "1rem !important",
                }}
              >
                <Typography
                  color="text.secondary"
                  component="div"
                  variant="h6"
                  sx={{ fontSize: "1em", mb: 1 }}
                >
                  {card.name}
                </Typography>
                <Typography
                  variant="h5"
                  color="text.main"
                  component="div"
                  sx={{ fontSize: "1.25em" }}
                >
                  {card.value}
                </Typography>
              </CardContent>
            </>
          ) : (
            <CircularProgress sx={{ margin: "auto" }} />
          )}
        </Box>
      </Card>
    </Grid>
  ));
}
